import React, { useState, useEffect } from 'react';

/**
 * Degraded Mode Banner
 * 
 * Shows when backend returns X-UnityLove-Degraded: 1 header.
 * Non-blocking, dismissible, auto-hides when degraded clears.
 * Power Saver friendly (no animation).
 */
export const DegradedBanner = ({ isDegraded, onRefresh }) => {
  const [dismissed, setDismissed] = useState(false);
  
  // Auto-show when degraded becomes true again
  useEffect(() => {
    if (isDegraded) {
      setDismissed(false);
    }
  }, [isDegraded]);
  
  // Don't render if not degraded or dismissed
  if (!isDegraded || dismissed) {
    return null;
  }
  
  return (
    <div 
      className="absolute top-16 left-1/2 transform -translate-x-1/2 z-50 max-w-md w-[90%]"
      role="alert"
      aria-live="polite"
    >
      <div className="bg-amber-900/95 border border-amber-700 rounded-lg px-4 py-3 flex items-center justify-between gap-3 shadow-lg">
        <div className="flex items-center gap-2 text-amber-100 text-sm">
          <span className="text-amber-400">⚠️</span>
          <span>Universe is warming up — showing limited signals.</span>
        </div>
        
        <div className="flex items-center gap-2 shrink-0">
          {onRefresh && (
            <button
              onClick={onRefresh}
              className="text-amber-300 hover:text-amber-100 text-xs font-medium px-2 py-1 rounded hover:bg-amber-800/50 transition-colors"
              aria-label="Refresh"
            >
              Refresh
            </button>
          )}
          <button
            onClick={() => setDismissed(true)}
            className="text-amber-400 hover:text-amber-200 p-1 rounded hover:bg-amber-800/50 transition-colors"
            aria-label="Dismiss"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DegradedBanner;
